import { FC } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import * as React from "react";

type ConfirmationModalProps = {
  modalDescription?: string;
  confirmationModalTitle: string;
  confirmBtnTitle?: string;
  cancelBtnTitle?: string;
  cancelAction: () => void;
  handleAction: () => void;
  confirmButtonColor?: string;
};
const ConfirmationModal: FC<ConfirmationModalProps> = ({
  modalDescription,
  confirmationModalTitle,
  confirmBtnTitle,
  cancelBtnTitle,
  cancelAction,
  handleAction,
  confirmButtonColor
}) => {
  return (
      <>
        <Dialog
            open
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
         >
          <DialogTitle id="alert-dialog-title">
            {confirmationModalTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {modalDescription}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              cancelAction()
            }}>{cancelBtnTitle}</Button>
            <Button onClick={() => {
              handleAction()
            }}
                    sx={{
                      '&:hover': {
                        backgroundColor: confirmButtonColor ?? "green",
                        color: "white"
                      }
                    }}
            >
              {confirmBtnTitle}
            </Button>
          </DialogActions>
        </Dialog>
        </>
  );
};
export default ConfirmationModal;
